export const ADS_SCRIPT_URL =
  "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1390523041207307";
export const PUBLISHER_SCRIPT_URL = "https://news.google.com/swg/js/v1/publisher.js";

/** Browser-only, idempotent: extras must not mutate the page before hydration. */
export function loadExternalScript(src: string, crossOrigin?: string): void {
  if (typeof document === "undefined") return;
  if (Array.from(document.scripts).some((script) => script.src === src)) return;
  const script = document.createElement("script");
  script.src = src;
  script.async = true;
  if (crossOrigin) script.crossOrigin = crossOrigin;
  document.head.appendChild(script);
}